import * as actions from './constants';

export const defaultState = {
    ticketId: null,
    processing: false, 
    error: null,
    done: false
}

export default function(state = defaultState, action) {
    const { type, payload=null, error=null } = action;
    switch(type) {
     
        case actions.DO_ACCEPTRESERVATION_START: {
            return {
                ...defaultState,
                ticketId: payload,
                processing: true
            }
        }

        case actions.DO_ACCEPTRESERVATION_SUCCESS: {
            return {
                ...defaultState,
                done: payload || true
            }
        }

        case actions.DO_ACCEPTRESERVATION_FAILURE: {
            return {
                ...defaultState,
                error
            }
        }
        
        default: {
            return state;
        }
    }
}